import { Lock } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

const fmtRemaining = (ms) => {
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return d > 0 ? `${d} hari ${pad(h)}:${pad(m)}:${pad(sec)}` : `${pad(h)}:${pad(m)}:${pad(sec)}`;
};

export const AccessBar = ({ user, now }) => {
  if (user.locked) {
    return (
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2 border border-sell/50 bg-sell/10 px-4 py-2.5" data-testid="access-bar-locked">
        <p className="font-mono text-[10px] font-bold uppercase tracking-widest text-sell">
          Akun dikunci admin — sinyal terkunci, harga & berita tetap terbuka
        </p>
        <button onClick={() => window.dispatchEvent(new Event("open-support"))} data-testid="access-bar-locked-contact"
          className="border border-sell bg-sell/20 px-3 py-1 font-mono text-[10px] font-bold text-white transition-colors hover:bg-sell">
          HUBUNGI ADMIN
        </button>
      </div>
    );
  }
  if (!user.access_expires) return null;
  const remaining = new Date(user.access_expires).getTime() - now.getTime();
  if (remaining <= 0) {
    return (
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2 border border-sell/50 bg-sell/10 px-4 py-2.5" data-testid="access-bar-expired">
        <p className="font-mono text-[10px] font-bold uppercase tracking-widest text-sell">
          Akses sinyal berakhir — hubungi admin untuk perpanjang
        </p>
        <button onClick={() => window.dispatchEvent(new Event("open-support"))} data-testid="access-bar-contact"
          className="border border-sell bg-sell/20 px-3 py-1 font-mono text-[10px] font-bold text-white transition-colors hover:bg-sell">
          HUBUNGI ADMIN
        </button>
      </div>
    );
  }
  const label = user.tier === "PREMIUM" ? "Paket PREMIUM" : "Trial gratis";
  return (
    <div className="mb-3 flex items-center gap-2 border border-buy/30 bg-buy/5 px-4 py-2" data-testid="access-bar">
      <Lock size={11} className="shrink-0 text-buy" />
      <p className="font-mono text-[10px] uppercase tracking-widest text-mute">
        {label} · sisa akses sinyal: <span className="font-bold text-buy" data-testid="access-countdown">{fmtRemaining(remaining)}</span>
      </p>
    </div>
  );
};
